import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { Stat } from '../../dashboard.interfaces';
import { StatDisplayComponent } from '../components/stat-display/stat-display.component';

@Component({
  selector: 'etoh-stats-display',
  templateUrl: './stats-display.component.html',
  styleUrls: ['./stats-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FlexLayoutModule,
    CommonModule,
    StatDisplayComponent,
    NzGridModule,
    NzDividerModule,
  ],
})
export class StatsDisplayComponent {
  stats = input.required<Stat[]>();

  nzSpan = input(12);
}
